

































































































































































































































































































































































































































































































































































































































































import Card from "@/components/UI/Card.vue";
import LocalData from "@/mixins/local-data";
import {Component, Mixins} from "vue-property-decorator";
import Http from '../mixins/http';
import Toast from '../mixins/toast';
import MarketSelect from "@/components/MarketSelect.vue";
import {SelectBox, SelectMarket} from "@/interfaces/global-data";
import Modal from "@/components/UI/Modal.vue";
import MasterData from "@/components/MasterData.vue";
import {
  AssortmentDirectoryFilterOptions,
  AssortmentDirectoryFilterOptionsParams,
  AssortmentDirectoryItem,
  AssortmentDirectoryParams,
  isUpdatingStatus,
  LastAssortmentUpdatingStatus,
  TaskInfoFilterType,
  VlGapType
} from "@/interfaces/server-data";
import {toSortOrder} from "@/utils/utils";
import vSelect from "@/components/UI/vSelect.vue";
import CollapseCard from "@/components/UI/CollapseCard.vue";
import MultiSelect from "@/components/MultiSelect.vue";
import moment from "moment";
import { Formatter } from '@/helpers/formatters';
import { isLicardClient } from '@/helpers/clientDetector';
@Component({
  computed: {
    MasterData() {
      return MasterData
    }
  },
  components: {
    MultiSelect, CollapseCard, vSelect,
    Modal,
    MarketSelect,
    Card
  },
})
export default class AssortmentDirectory extends Mixins(Http, Toast, LocalData) {
  directoryFilesMarket = localStorage.getItem('directory_files_market');
  selectMarket: SelectMarket | null = this.directoryFilesMarket ? JSON.parse(this.directoryFilesMarket) : null;

  assortmentDirectoryTableIdName: string = 'assortmentDirectoryTable'

  tableLoader = {
    counter: 0,
    message: '',

    acquire() {
      this.counter++
    },

    release() {
      this.counter--
    },

    isLoading() {
      return this.counter > 0;
    },

    reset() {
      this.counter = 0
    }
  }

  customSpin() {
    return {
      spinning: this.tableLoader.isLoading(),
      tip: this.tableLoader.message
    }
  }

  lastAssortmentUpdatingStatus: LastAssortmentUpdatingStatus = LastAssortmentUpdatingStatus.DONE
  lastAssortmentUpdatingPreviousStatus: LastAssortmentUpdatingStatus = LastAssortmentUpdatingStatus.DONE
  isLastAssortmentUpdating: boolean = false

  resetAssortUpdStatus() {
    this.lastAssortmentUpdatingStatus = LastAssortmentUpdatingStatus.DONE
    this.lastAssortmentUpdatingPreviousStatus = LastAssortmentUpdatingStatus.DONE
    this.isLastAssortmentUpdating = false
  }

  assortmentDirectoryFile: File | null = null
  errorsAmount: number = 0

  updateLastAssortmentModal: boolean = false

  assortmentDirectoryItems: AssortmentDirectoryItem[] = []

  pagination = {
    current: 1,
    pageSize: 50,
    total: 0,
    position: 'bottom',
  }

  sortingDefaultField = 'id'
  sortingDefaultDirection = 'ASC'
  sorting = {
    field: this.sortingDefaultField,
    direction: this.sortingDefaultDirection
  }

  defaultFilterValue = {value: -1, label: this.$t('shared.selectBox.all') as string}
  secondDefaultFilterValue = {value: -2, label: this.$t('shared.selectBox.notSelected') as string}
  defaultMultipleValue = [this.defaultFilterValue, this.secondDefaultFilterValue];

  defaultMultiValue = [this.defaultFilterValue]

  selectFormat: number[] = [];
  formatOptions: SelectBox<number>[] = [this.defaultFilterValue];

  selectRegion: number[] = [];
  regionOptions: SelectBox<number>[] = [this.defaultFilterValue];

  selectCluster: number[] = [];
  clusterOptions: SelectBox<number>[] = [this.defaultFilterValue];

  selectGroup: number[] = [];
  groupOptions: SelectBox<number>[] = [this.defaultFilterValue];

  selectCategory: number[] = [];
  categoryOptions: SelectBox<number>[] = [this.defaultFilterValue];

  selectSubcategory: number[] = [];
  subcategoryOptions: SelectBox<number>[] = [this.defaultFilterValue];

  selectInternalCode: string | null = null;
  selectSkuName: string | null = null;
  selectProductLine: string | null = null;
  selectProductVerticalLine: string | null = null;
  selectVlGapType: VlGapType = null;

  selectedKvi: number = -1;
  selectedCtm: number = -1;
  selectedProductVerticalLines: string[] = [];
  selectedMinRetailPrices: number[] = [];
  selectedMaxRetailPrices: number[] = [];

  filterDropdownsState: any = {};
  filterDropdownsRange: any = {
    from: {},
    to: {},
  };
  filterAllCheckboxCheckedState: any = {};
  tableFilterOptions: any = {};

  assortmentDirectoryTableFields: any[] = [
    {
      key: 'storeFormat',
      dataIndex: 'storeFormat',
      title: this.$t('masterData.assortment.table.storeFormat') as string,
      scopedSlots: {
        customRender: 'storeFormat',
        filterDropdown: 'storeFormatFilter',
        filterIcon: "storeFormatFilterIcon"
      },
      width: 160,
      sorter: true,
      ellipsis: true,
    },
    {
      key: 'storeRegion',
      dataIndex: 'storeRegion',
      title: this.$t('masterData.assortment.table.region') as string,
      scopedSlots: {
        customRender: 'storeRegion',
        filterDropdown: 'storeRegionFilter',
        filterIcon: "storeRegionFilterIcon"
      },
      width: 100,
      sorter: true,
      ellipsis: true,
    },
    {
      key: 'storeCluster',
      dataIndex: 'storeCluster',
      title: this.$t('masterData.assortment.table.storeCluster') as string,
      scopedSlots: {
        customRender: 'storeCluster',
        filterDropdown: 'storeClusterFilter',
        filterIcon: "storeClusterFilterIcon"
      },
      width: 160,
      sorter: true,
      ellipsis: true
    },
    {
      key: 'group',
      dataIndex: 'group',
      title: this.$t('masterData.assortment.table.productGroup') as string,
      scopedSlots: {
        customRender: 'group',
        filterDropdown: 'groupFilter',
        filterIcon: "groupFilterIcon"
      },
      width: 140,
      sorter: true,
      ellipsis: true,
    },
    {
      key: 'category',
      dataIndex: 'category',
      title: this.$t('masterData.assortment.table.productCategory') as string,
      scopedSlots: {
        customRender: 'category',
        filterDropdown: 'categoryFilter',
        filterIcon: "categoryFilterIcon"
      },
      width: 170,
      sorter: true,
      ellipsis: true,
    },
    {
      key: 'subcategory',
      dataIndex: 'subcategory',
      title: this.$t('masterData.assortment.table.productSubcategory') as string,
      scopedSlots: {
        customRender: 'subcategory',
        filterDropdown: 'subcategoryFilter',
        filterIcon: "subcategoryFilterIcon"
      },
      width: 200,
      sorter: true,
      ellipsis: true,
    },
    {
      key: 'internalCode',
      dataIndex: 'internalCode',
      title: this.$t('masterData.assortment.table.internalCode') as string,
      scopedSlots: {
        title: 'internalCodeTitle',
        customRender: 'internalCode',
        filterDropdown: 'internalCodeFilter',
        filterIcon: "internalCodeFilterIcon"
      },
      width: 150,
      sorter: true,
      // ellipsis: true,
    },
    {
      key: 'skuName',
      dataIndex: 'skuName',
      title: this.$t('masterData.assortment.table.skuName') as string,
      scopedSlots: {
        customRender: 'skuName',
        filterDropdown: 'skuNameFilter',
        filterIcon: "skuNameFilterIcon"
      },
      width: 200,
      sorter: true,
      ellipsis: true,
    },
    {
      key: 'kvi',
      dataIndex: 'kvi',
      title: 'KVI',
      filterOptionsKey: 'kvi',
      filterModel: 'kvi',
      showRange: false,
      onFilterDropdownVisibleChange: () => { this.filterDropdownVisibleChange('kvi') },
      scopedSlots: {
        customRender: 'kvi',
        filterDropdown: 'kviFilter',
        filterIcon: "kviFilterIcon"
      },
      width: 70,
    },
    {
      key: 'ctm',
      dataIndex: 'ctm',
      title: this.$t('masterData.assortment.table.ctm') as string,
      filterOptionsKey: 'ctm',
      filterModel: 'ctm',
      showRange: false,
      onFilterDropdownVisibleChange: () => { this.filterDropdownVisibleChange('ctm') },
      scopedSlots: {
        customRender: 'ctm',
        filterDropdown: 'ctmFilter',
        filterIcon: "ctmFilterIcon"
      },
      width: 70,
    },
    {
      key: 'ctmBrandPurpose',
      dataIndex: 'ctmBrandPurpose',
      title: this.$t('masterData.assortment.table.ctmBrandPurpose') as string,
      scopedSlots: {
        customRender: 'ctmBrandPurpose'
      },
      width: 150,
    },
    {
      key: 'priceGapStm',
      dataIndex: 'priceGapStm',
      title: this.$t('masterData.assortment.table.priceGapStm') as string,
      scopedSlots: {
        customRender: 'priceGapStm'
      },
      width: 130,
    },
    {
      key: 'productLine',
      dataIndex: 'productLine',
      title: this.$t('masterData.assortment.table.productLine') as string,
      scopedSlots: {
        customRender: 'productLine',
        filterDropdown: 'productLineFilter',
        filterIcon: "productLineFilterIcon",
      },
      width: 120,
      ellipsis: true,
    },
    {
      key: 'purchasePrice',
      dataIndex: 'purchasePrice',
      title: this.$t('masterData.assortment.table.purchasePrice') as string,
      scopedSlots: {
        customRender: 'purchasePrice'
      },
      width: 120,
    },
    {
      key: 'minRetailPrice',
      dataIndex: 'minRetailPrice',
      title: this.$t('masterData.assortment.table.minRetailPrice') as string,
      filterOptionsKey: 'minRetailPrices',
      filterModel: 'minRetailPrice',
      showRange: true,
      onFilterDropdownVisibleChange: () => { this.filterDropdownVisibleChange('minRetailPrice') },
      scopedSlots: {
        customRender: 'minRetailPrice',
        filterDropdown: 'minRetailPriceFilter',
        filterIcon: "minRetailPriceFilterIcon"
      },
      width: 150,
    },
    {
      key: 'maxRetailPrice',
      dataIndex: 'maxRetailPrice',
      title: this.$t('masterData.assortment.table.maxRetailPrice') as string,
      filterOptionsKey: 'maxRetailPrices',
      filterModel: 'maxRetailPrice',
      showRange: true,
      onFilterDropdownVisibleChange: () => { this.filterDropdownVisibleChange('maxRetailPrice') },
      scopedSlots: {
        customRender: 'maxRetailPrice',
        filterDropdown: 'maxRetailPriceFilter',
        filterIcon: "maxRetailPriceFilterIcon"
      },
      width: 150,
    },
    {
      key: 'keyCharacteristicOfTheProductIsOne',
      dataIndex: 'keyCharacteristicOfTheProductIsOne',
      title: this.$t('masterData.assortment.table.kht1') as string,
      scopedSlots: {
        customRender: 'keyCharacteristicOfTheProductIsOne'
      },
      width: 130,
      ellipsis: true,
    },
    {
      key: 'keyCharacteristicOfTheProductIsTwo',
      dataIndex: 'keyCharacteristicOfTheProductIsTwo',
      title: this.$t('masterData.assortment.table.kht2') as string,
      scopedSlots: {
        customRender: 'keyCharacteristicOfTheProductIsTwo'
      },
      width: 130,
      ellipsis: true,
    },
    {
      key: 'keyCharacteristicOfTheProductIsThree',
      dataIndex: 'keyCharacteristicOfTheProductIsThree',
      title: this.$t('masterData.assortment.table.kht3') as string,
      scopedSlots: {
        customRender: 'keyCharacteristicOfTheProductIsThree'
      },
      width: 130,
      ellipsis: true,
    },
    {
      key: 'keyCharacteristicOfTheProductIsFour',
      dataIndex: 'keyCharacteristicOfTheProductIsFour',
      title: this.$t('masterData.assortment.table.kht4') as string,
      scopedSlots: {
        customRender: 'keyCharacteristicOfTheProductIsFour'
      },
      width: 130,
      ellipsis: true,
    },
    {
      key: 'keyCharacteristicOfTheProductIsFive',
      dataIndex: 'keyCharacteristicOfTheProductIsFive',
      title: this.$t('masterData.assortment.table.kht5') as string,
      scopedSlots: {
        customRender: 'keyCharacteristicOfTheProductIsFive'
      },
      width: 130,
      ellipsis: true,
    },
    {
      key: 'markupPercentage',
      dataIndex: 'markupPercentage',
      title: this.$t('masterData.assortment.table.markupPercentage') as string,
      scopedSlots: {
        customRender: 'markupPercentage'
      },
      width: 120,
    },
    {
      key: 'basePrice',
      dataIndex: 'basePrice',
      title: this.$t('masterData.assortment.table.basePrice') as string,
      scopedSlots: {
        customRender: 'basePrice'
      },
      width: 140,
    },
    {
      key: 'vatPercentage',
      dataIndex: 'vatPercentage',
      title: this.$t('masterData.assortment.table.vatPercentage') as string,
      scopedSlots: {
        customRender: 'vatPercentage'
      },
      width: 100,
    },
    {
      key: 'logisticCostsAmount',
      dataIndex: 'logisticCostsAmount',
      title: this.$t('masterData.assortment.table.logisticCostsAmount') as string,
      scopedSlots: {
        customRender: 'logisticCostsAmount'
      },
      width: 130,
    },
    {
      key: 'logisticCostsPercentage',
      dataIndex: 'logisticCostsPercentage',
      title: this.$t('masterData.assortment.table.logisticCostsPercentage') as string,
      scopedSlots: {
        customRender: 'logisticCostsPercentage'
      },
      width: 120,
    },
    {
      key: 'marketingPaymentsPercentage',
      dataIndex: 'marketingPaymentsPercentage',
      title: this.$t('masterData.assortment.table.marketingPaymentsPercentage') as string,
      scopedSlots: {
        customRender: 'marketingPaymentsPercentage'
      },
      width: 120,
    },
    {
      key: 'productVolume',
      dataIndex: 'productVolume',
      title: this.$t('masterData.assortment.table.productVolume') as string,
      scopedSlots: {
        customRender: 'productVolume'
      },
      width: 70,
    },
    {
      key: 'measurementUnit',
      dataIndex: 'measurementUnit',
      title: this.$t('masterData.assortment.table.measurementUnit') as string,
      scopedSlots: {
        customRender: 'measurementUnit'
      },
      width: 50,
      ellipsis: true,
    },
    {
      key: 'productVerticalLine',
      dataIndex: 'productVerticalLine',
      title: this.$t('masterData.assortment.table.productVerticalLine') as string,
      scopedSlots: {
        customRender: 'productVerticalLine',
        filterDropdown: 'productVerticalLineFilter',
        filterIcon: "productVerticalLineFilterIcon",
      },
      width: 120,
      ellipsis: true,
    },
    {
      key: 'isVerticalLineBase',
      dataIndex: 'isVerticalLineBase',
      title: this.$t('masterData.assortment.table.isVerticalLineBase') as string,
      scopedSlots: {
        customRender: 'isVerticalLineBase'
      },
      width: 90,
      ellipsis: true,
    },
    {
      key: 'vlStrategy',
      dataIndex: 'vlStrategy',
      title: this.$t('masterData.assortment.table.vlStrategy') as string,
      scopedSlots: {
        customRender: 'vlStrategy'
      },
      width: 120,
      ellipsis: true,
    },
    {
      key: 'vlGapPc',
      dataIndex: 'vlGapPc',
      title: this.$t('masterData.assortment.table.vlGapPc') as string,
      customRender: (_value: any, record: AssortmentDirectoryItem) =>
        Formatter.vlGap(record.vlGapPc, record.vlGapType),
      width: 130,
      ellipsis: false,
      // Фильтр по типу разрыва ВЛ временно отключён (см. SP-70907)
      ...(false && isLicardClient() ? {
        scopedSlots: {
          filterDropdown: 'vlGapTypeFilter',
          filterIcon: 'vlGapTypeFilterIcon',
        },
      } : {}),
    },
    {
      key: 'targetMarginPc',
      dataIndex: 'targetMarginPc',
      title: this.$t('masterData.assortment.table.targetMarginPc') as string,
      scopedSlots: {
        customRender: 'targetMarginPc'
      },
      width: 120,
      ellipsis: false,
    },
    {
      key: 'status',
      dataIndex: 'status',
      title: this.$t('masterData.assortment.table.status') as string,
      scopedSlots: {
        customRender: 'status'
      },
      width: 100,
    }
  ]

  filterDropdownVisibleChange(filterModel: string) {
    this.filterDropdownsState[filterModel] = !this.filterDropdownsState[filterModel];
  }

  getFilterIconActivity(filterModel: string): boolean {
    if (filterModel === 'kvi') {
      return this.selectedKvi !== -1;
    }
    if (filterModel === 'ctm') {
      return this.selectedCtm !== -1;
    }

    const filterValue = (this as any)[this.getForDetailTableVariableName(filterModel)];

    return Array.isArray(filterValue)
      ? !!filterValue.length
      : !!filterValue || filterValue === 0;
  }

  handleCheckboxGroupChanged(filterModel: string, value: string | number[]) {
    const variableName = this.getForDetailTableVariableName(filterModel);

    if (filterModel === 'minRetailPrice' || filterModel === 'maxRetailPrice') {
      const prev = Array.isArray((this as any)[variableName]) ? (this as any)[variableName] as (number | string)[] : [];
      const filterOptionsKey = filterModel === 'minRetailPrice' ? 'minRetailPrices' : 'maxRetailPrices';

      const visibleOptions = this.getFilterOptions(filterModel, filterOptionsKey, true)
        .map((o: SelectBox<number> | SelectBox<string>) => o.value);

      const nextVisibleSelected = Array.isArray(value) ? value as (number | string)[] : [];

      const keptFromPrev = prev.filter(v => !visibleOptions.includes(v));
      const merged = Array.from(new Set([...keptFromPrev, ...nextVisibleSelected]));

      (this as any)[variableName] = merged;

      this.filterAllCheckboxCheckedState[filterModel] =
        visibleOptions.length > 0 && nextVisibleSelected.length === visibleOptions.length;
    } else {
      (this as any)[variableName] = value;
    }

    if (filterModel === 'productVerticalLine') {
      const options = this.tableFilterOptions.productVerticalLineNames || [];
      this.filterAllCheckboxCheckedState['productVerticalLine'] =
        Array.isArray(value) && value.length === options.length;
    }

    this.pagination.current = 1;
  }

  handleAllCheckboxChanged(value: boolean, filterModel: string, filterOptionsKey: string, useRange: boolean = false) {
    this.filterAllCheckboxCheckedState[filterModel] = value;

    const variableName = this.getForDetailTableVariableName(filterModel);

    if (value) {
      (this as any)[variableName] = [
        ...new Set([
          ...(this as any)[variableName],
          ...this.getFilterOptions(filterModel, filterOptionsKey, useRange).map((option: SelectBox<number> | SelectBox<string>) => option.value),
        ])
      ];
    } else {
      const optionValuesToDeselect = this.getFilterOptions(filterModel, filterOptionsKey, useRange).map((option: SelectBox<number> | SelectBox<string>) => option.value);

      (this as any)[variableName] = (this as any)[variableName].filter((val: string | number) => !optionValuesToDeselect.includes(val));
    }
  }

  getFilterOptions(filterModel: string, filterOptionsKey: string, useRange: boolean = false) {
    if (!this.tableFilterOptions[filterOptionsKey]) {
      return [];
    }

    if (useRange) {
      return this.tableFilterOptions[filterOptionsKey].filter((option: SelectBox<number>) => {
        if ((this.filterDropdownsRange.from[filterModel] || this.filterDropdownsRange.from[filterModel] === 0) && !(this.filterDropdownsRange.to[filterModel] || this.filterDropdownsRange.to[filterModel] === 0)) {
          return option.value >= this.filterDropdownsRange.from[filterModel];
        } else if (!(this.filterDropdownsRange.from[filterModel] || this.filterDropdownsRange.from[filterModel] === 0) && (this.filterDropdownsRange.to[filterModel] || this.filterDropdownsRange.to[filterModel] === 0)) {
          return option.value <= this.filterDropdownsRange.to[filterModel];
        } else if ((this.filterDropdownsRange.from[filterModel] || this.filterDropdownsRange.from[filterModel] === 0) && (this.filterDropdownsRange.to[filterModel] || this.filterDropdownsRange.to[filterModel] === 0)) {
          return this.filterDropdownsRange.from[filterModel] <= option.value && option.value <= this.filterDropdownsRange.to[filterModel];
        } else {
          return true;
        }
      })
    } else {
      return this.tableFilterOptions[filterOptionsKey] || [];
    }
  }

  getVariable(variableName: string) {
    return (this as any)[variableName];
  }

  getForDetailTableVariableName(filterModel: string): string {
    let key = filterModel;

    if (key === 'KVI') return 'selectedKvi';
    if (key === 'CTM') return 'selectedCtm';
    if (key === 'productVerticalLine') return 'selectedProductVerticalLines';
    if (key === 'minRetailPrice') return 'selectedMinRetailPrices';
    if (key === 'maxRetailPrice') return 'selectedMaxRetailPrices';

    return key;
  }

  getKviFilterValue(): boolean | null {
    if (this.selectedKvi === -1 || this.selectedKvi === null || this.selectedKvi === undefined) return null;
    return this.selectedKvi === 1;
  }

  getCtmFilterValue(): boolean | null {
    if (this.selectedCtm === -1 || this.selectedCtm === null || this.selectedCtm === undefined) return null;
    return this.selectedCtm === 1;
  }

  filterParams(): AssortmentDirectoryParams {
    let selectStoreFormat = this.removeDefaultOption(this.selectFormat)
    let selectStoreRegion = this.removeDefaultOption(this.selectRegion)
    let selectStoreCluster = this.removeDefaultOption(this.selectCluster)
    let selectGroup = this.removeDefaultOption(this.selectGroup)
    let selectCategory = this.removeDefaultOption(this.selectCategory)
    let selectSubcategory = this.removeDefaultOption(this.selectSubcategory)

    return {
      tradingId: this.selectMarket!!.id,
      internalCode: !!this.selectInternalCode ? this.selectInternalCode : null,
      skuName: !!this.selectSkuName ? this.selectSkuName : null,
      productLine: !!this.selectProductLine ? this.selectProductLine : null,
      productVerticalLine: !!this.selectProductVerticalLine ? this.selectProductVerticalLine : null,
      vlGapType: this.selectVlGapType,
      kviFilter: this.getKviFilterValue(),
      ctmFilter: this.getCtmFilterValue(),
      selectedProductVerticalLines: this.selectedProductVerticalLines.length > 0 ? this.selectedProductVerticalLines : null,
      selectedMinRetailPrices: this.selectedMinRetailPrices.length > 0 ? this.selectedMinRetailPrices : null,
      selectedMaxRetailPrices: this.selectedMaxRetailPrices.length > 0 ? this.selectedMaxRetailPrices : null,
      storeFormatIds: selectStoreFormat.length > 0 ? selectStoreFormat : null,
      storeRegionIds: selectStoreRegion.length > 0 ? selectStoreRegion : null,
      storeClusterIds: selectStoreCluster.length > 0 ? selectStoreCluster : null,
      groupIds: selectGroup.length > 0 ? selectGroup : null,
      categoryIds: selectCategory.length > 0 ? selectCategory : null,
      subcategoryIds: selectSubcategory.length > 0 ? selectSubcategory : null,
      page: this.pagination.current - 1,
      size: this.pagination.pageSize,
      sortField: this.sorting.field,
      sortDirection: this.sorting.direction
    }
  }

  filterOptionsParams(): AssortmentDirectoryFilterOptionsParams {
    let filterParams = this.filterParams()
    return {
      selectedGroups: filterParams.groupIds,
      selectedCategories: filterParams.categoryIds,
      selectedSubcategories: filterParams.subcategoryIds,
      selectedStoreFormats: filterParams.storeFormatIds,
      selectedStoreRegions: filterParams.storeRegionIds,
      selectedStoreClusters: filterParams.storeClusterIds,
      selectedVerticalLines: filterParams.selectedProductVerticalLines,
      selectedMinRetailPrices: filterParams.selectedMinRetailPrices,
      selectedMaxRetailPrices: filterParams.selectedMaxRetailPrices,
      ctm: filterParams.ctmFilter,
      kvi: filterParams.kviFilter
    }
  }

  mounted() {
    this.tableFilterOptions.kvi = [
      {value: -1, label: this.$t('masterData.assortment.filters.notSelectedKvi')},
      {value: 1, label: this.$t('masterData.assortment.filters.kvi')},
      {value: 0, label: this.$t('masterData.assortment.filters.notKvi')},
    ];
    this.tableFilterOptions.ctm = [
      {value: -1, label: this.$t('masterData.assortment.filters.notSelectedCtm')},
      {value: 1, label: this.$t('masterData.assortment.filters.ctm')},
      {value: 0, label: this.$t('masterData.assortment.filters.notCtm')},
    ];

    if (!!this.selectMarket) {
      this.tableLoader.reset()

      this.resetAssortUpdStatus()
      this.fetchAllData()
    }
  }

  beforeDestroy() {
    // Очистка таймера при уничтожении компонента
    if (this.intervalId) {
      clearInterval(this.intervalId)
    }
  }

  fetchAllData() {
    this.fetchFilterOptions()
    this.fetchAssortmentDirectory()
    this.getErrorsAmount()
    this.startIntervalForFetchingAssortUpdStatus()
  }

  intervalId: number | null = null
  startIntervalForFetchingAssortUpdStatus() {
    // Очистка предыдущего таймера, если он существует
    if (this.intervalId) {
      clearInterval(this.intervalId)
    }

    // Установка нового таймера
    this.intervalId = setInterval(this.getUpdatingLastAssortmentStatus, 10_000);
    this.getUpdatingLastAssortmentStatus(); // Немедленный вызов при изменении
  }

  removeDefaultOption(arr: number[]): number[] {
    return arr.filter(item => item != this.defaultMultiValue[0].value)
  }

  updateSelectMarket(market: SelectMarket) {
    this.$log.debug('Files updateSelectMarket', market);
    this.selectMarket = market;
    localStorage.setItem('directory_files_market', JSON.stringify(market))

    // Сбрасываем tableLoader, когда переходим в другую ТК
    this.tableLoader.reset()
    this.resetAssortUpdStatus()
    this.fetchAllData()
  }

  badgeStyle(errorsAmount: number | null) {
    const condition = !!errorsAmount
    return {
      backgroundColor: 'white',
      size: '10px',
      color: condition ? 'red' : 'gray',
      borderColor: condition ? 'red' : 'gray'
    }
  }

  noOneFormatIsSelected(): boolean {
    return this.selectFormat.length == 0 ||
        (this.selectFormat.length == 1 && this.selectFormat[0] == this.defaultFilterValue.value)
  }

  disableUploadButtons(): boolean {
    return !this.assortmentDirectoryFile || !this.selectMarket
  }

  get showVlGapHint(): boolean {
    return isLicardClient();
  }

  disableUpdateLastAssortmentButton() {
    return this.tableLoader.isLoading()
  }

  disableExportButton() {
    return this.tableLoader.isLoading()
        || this.noOneFormatIsSelected()
  }

  disableFileInput() {
    return this.tableLoader.isLoading()
  }

  disableApplyFiltersButton() {
    return this.tableLoader.isLoading()
  }

  showUpdateLastAssortmentModal() {
    this.updateLastAssortmentModal = true
  }

  uploadAssortmentDirectoryFile() {
    if (!this.assortmentDirectoryFile) {
      this.showError(this.$t('shared.messages.selectFile') as string);
      return;
    }
    if (!this.selectMarket) {
      this.showError(this.$t('shared.messages.selectTradingCampaign') as string);
      return;
    }
    const uploadFile = new FormData();
    uploadFile.append(
        'file',
        new Blob([this.assortmentDirectoryFile]),
        this.assortmentDirectoryFile.name
    );
    this.tableLoader.acquire()
    this.httpUploadAssortmentDirectoryFile(this.selectMarket.id, uploadFile)
        .then((r) => {
          this.showInfo(r.data ? r.data : this.$t('shared.messages.fileUploadedSuccess') as string);
          this.assortmentDirectoryFile = null;
        })
        .catch((e) => {
          this.showError(this.$t('shared.messages.errorUploadFile') as string);
          this.assortmentDirectoryFile = null;
        })
        .finally(() => {
          this.tableLoader.release()
          this.fetchAllData()
        });
  }

  fetchAssortmentDirectory() {
    if (!!this.selectMarket) {
      this.tableLoader.acquire()
      this.httpGetAssortmentDirectoryItems(
          this.filterParams()
      ).then((r) => {
        this.assortmentDirectoryItems = r.data.content
        this.pagination.total = r.data.totalElements
      }).finally(() => {
        this.tableLoader.release()
      })
    }
  }

  getErrorsAmount() {
    if (!this.selectMarket) {
      return;
    }
    this.httpGetAssortmentDirectoryErrorsAmount(this.selectMarket.id)
        .then((r) => {
          this.errorsAmount = r.data
        })
  }

  downloadErrors() {
    if (!this.selectMarket) {
      this.showError(this.$t('shared.messages.selectTradingNetwork') as string);
      return;
    }
    this.tableLoader.acquire()
    this.httpGetAssortmentDirectoryErrors(this.selectMarket.id)
        .then((response) => {
          if (!response.data.size) {
            this.showInfo(this.$t('shared.messages.noErrors') as string)
            return;
          }

          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', this.$t('masterData.assortment.errorsDownloadFileName') as string);

          document.body.appendChild(link);
          link.click();
        })
        .finally(() => {
          this.tableLoader.release()
        });
  }

  handleTableChange(pagination: any, filters: any, sorter: any) {
    this.pagination = pagination;

    this.sorting.field = sorter.field
    this.sorting.direction = toSortOrder(sorter.order)
    if (!sorter.order) {
      this.sorting.field = this.sortingDefaultField
      this.sorting.direction = this.sortingDefaultDirection
    }

    this.fetchAssortmentDirectory();
  }

  fetchFilterOptions(layer: TaskInfoFilterType = TaskInfoFilterType.group) {
    if (!this.selectMarket) {
      return;
    }
    this.fetchAndSetFilterOptions(layer)
  }

  fetchAndSetFilterOptions(layer: TaskInfoFilterType | undefined) {
    if (!this.selectMarket) {
      return;
    }
    this.httpGetAssortmentDirectoryFilterOptions(this.selectMarket!!.id, this.filterOptionsParams())
        .then((r) => {
          this.setFilterOptions(r.data, layer)
        })
  }

  // Специально отсутствуют break, чтобы цепочка шла от наибольшего уровня к наименьшему
  setFilterOptions(data: AssortmentDirectoryFilterOptions, type: TaskInfoFilterType | undefined) {
    if (!!type) {
      switch (type) {
        case TaskInfoFilterType.group:
          this.selectGroup = []
          this.groupOptions = data.groups.map(item => {
            return {
              value: item.id,
              label: item.name
            }
          })

        case TaskInfoFilterType.category:
          this.selectCategory = []
          this.categoryOptions = data.categories.map(item => {
            return {
              value: item.id,
              label: item.name
            }
          })

        case TaskInfoFilterType.subcategory:
          this.selectSubcategory = []
          this.subcategoryOptions = data.subcategories.map(item => {
            return {
              value: item.id,
              label: item.name
            }
          })

        case TaskInfoFilterType.format:
          this.selectFormat = []
          this.formatOptions = data.storeFormats.map(item => {
            return {
              value: item.id,
              label: item.name
            }
          })

        case TaskInfoFilterType.region:
          this.selectRegion = []
          this.regionOptions = data.storeRegions.map(item => {
            return {
              value: item.id,
              label: item.name
            }
          })

        case TaskInfoFilterType.cluster:
          this.selectCluster = []
          this.clusterOptions = data.storeClusters.map(item => {
            return {
              value: item.id,
              label: item.name
            }
          })

        default:
          break;
      }
    }
    
    this.tableFilterOptions.productVerticalLineNames = data.productVerticalLineNames.map(name => ({
      value: name,
      label: name
    }));
    
    this.tableFilterOptions.minRetailPrices = data.minRetailPrices.map(price => ({
      value: price,
      label: String(price)
    }));
    
    this.tableFilterOptions.maxRetailPrices = data.maxRetailPrices.map(price => ({
      value: price,
      label: String(price)
    }));
  }

  updateProductGroup(selectedGroups: number[]) {
    if (selectedGroups.length > 0 && !LocalData.compareTwoArrays(selectedGroups, this.selectGroup)) {
      this.selectGroup = selectedGroups
      this.fetchAndSetFilterOptions(TaskInfoFilterType.category)
    }
  }

  updateProductCategory(selectedCategories: number[]) {
    if (selectedCategories.length > 0 && !LocalData.compareTwoArrays(selectedCategories, this.selectCategory)) {
      this.selectCategory = selectedCategories
      this.fetchAndSetFilterOptions(TaskInfoFilterType.subcategory)
    }
  }

  updateSubcategories(selectedSubcategories: number[]) {
    if (selectedSubcategories.length > 0 && !LocalData.compareTwoArrays(selectedSubcategories, this.selectSubcategory)) {
      this.selectSubcategory = selectedSubcategories
      this.fetchAndSetFilterOptions(TaskInfoFilterType.format)
    }
  }

  updateStoreFormats(selectedFormats: number[]) {
    if (selectedFormats.length > 0 && !LocalData.compareTwoArrays(selectedFormats, this.selectFormat)) {
      this.selectFormat = selectedFormats
      this.fetchAndSetFilterOptions(TaskInfoFilterType.region)
    }
  }

  updateRegions(selectedRegions: number[]) {
    if (selectedRegions.length > 0 && !LocalData.compareTwoArrays(selectedRegions, this.selectRegion)) {
      this.selectRegion = selectedRegions
      this.fetchAndSetFilterOptions(TaskInfoFilterType.cluster)
    }
  }

  updateClusters(selectedClusters: number[]) {
    if (selectedClusters.length > 0 && !LocalData.compareTwoArrays(selectedClusters, this.selectCluster)) {
      this.selectCluster = selectedClusters
      this.fetchAndSetFilterOptions(undefined)
    }
  }

  applyFilters() {
    this.fetchAssortmentDirectory()
  }

  downloadAssortmentDirectoryFile() {
    if (!this.selectMarket) {
      this.showError(this.$t('shared.messages.selectTradingNetwork') as string);
      return;
    }
    this.tableLoader.acquire()
    this.httpGetAssortmentDirectoryFile(this.filterParams())
        .then((response) => {
          let extension = response.data.type == 'application/zip' ? '.zip' : '.xlsx'
          let dateString = moment().format('YYYYMMDD_HHmmss')
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute(
              'download',
              this.$t('masterData.assortment.exportFileName') + '_' + this.selectMarket!!.tradingName + '_' + dateString + extension
          );

          document.body.appendChild(link);
          link.click();
        })
        .finally(() => {
          this.tableLoader.release()
        });
  }

  updateLastAssortment() {
    if (!this.selectMarket) {
      this.showError(this.$t('shared.messages.selectTradingNetwork') as string);
      return;
    }
    this.tableLoader.acquire()
    this.httpUpdateLastAssortmentByAssortmentDirectory(this.selectMarket.id)
        .then((r) => {
          this.setLastAssortmentUpdatingStatus(LastAssortmentUpdatingStatus.UPDATING_ASSORTMENT_BY_ASSORTMENT_DIRECTORY)
          this.startIntervalForFetchingAssortUpdStatus()
        })
        .finally(() => {
          this.tableLoader.release()
        })
  }

  getUpdatingLastAssortmentStatus() {
    if (!this.selectMarket) {
      return;
    }
    this.httpGetLastAssortmentUpdatingByAssortmentDirectoryStatus(this.selectMarket.id)
        .then((r) => {
          this.setLastAssortmentUpdatingStatus(r.data)
        })
        .finally(() => {

        })
  }

  setLastAssortmentUpdatingStatus(status: LastAssortmentUpdatingStatus) {
    this.lastAssortmentUpdatingPreviousStatus = this.lastAssortmentUpdatingStatus
    this.lastAssortmentUpdatingStatus = status
    this.isLastAssortmentUpdating = isUpdatingStatus(status)

    const sameUpdateProcess =
        this.lastAssortmentUpdatingStatus === this.lastAssortmentUpdatingPreviousStatus
        && this.isLastAssortmentUpdating

    if (this.isLastAssortmentUpdating) {
      if (!sameUpdateProcess) {
        this.tableLoader.acquire()
        this.tableLoader.message = this.getLocalizedStatusMessage(status)
      }

      return;
    }

    if (isUpdatingStatus(this.lastAssortmentUpdatingPreviousStatus)) {
      if (this.lastAssortmentUpdatingStatus === LastAssortmentUpdatingStatus.DONE) {
        this.showInfo(this.$t('shared.messages.lastAssortmentUpdateSuccess') as string)
      } else {
        this.showError(this.$t('shared.messages.errorUpdateLastAssortment') as string)
      }
      this.tableLoader.release()
      this.tableLoader.message = ''

      this.fetchAllData()
    }
  }

  getLocalizedStatusMessage(status: LastAssortmentUpdatingStatus): string {
    const statusMap: Record<string, string> = {
      [LastAssortmentUpdatingStatus.UPDATING_ASSORTMENT_BY_SALE_POINTS_DIRECTORY]:
        this.$t('shared.messages.updatingAssortmentBySalePointsDirectory') as string,
      [LastAssortmentUpdatingStatus.UPDATING_ASSORTMENT_BY_ASSORTMENT_DIRECTORY]:
        this.$t('shared.messages.updatingAssortmentByAssortmentDirectory') as string,
    }
    return statusMap[status] || ''
  }

}
